module.exports = __webpack_public_path__ + "img/foto1.18221127.jpg";